$(function () {
  $(".hamburger").click(function () {
    // メニューの開閉状態を切り替える
    $(".menu").addClass("open");
    $(".menu-bg").addClass("open");
  });

  $(".menu-close").click(function () {
    $(".menu").removeClass("open");
    $(".menu-bg").removeClass("open");
  });
  $(".menu-bg").click(function () {
    $(".menu").removeClass("open");
    $(".menu-bg").removeClass("open");
  });
  $("#js-slider").slick({
    arrows: false, // 前・次のボタンを表示する
    dots: false, // ドットナビゲーションを表示する
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000, // スライドさせるスピード（ミリ秒）
    slidesToShow: 1, // 表示させるスライド数
    centerMode: false, // slidesToShowが奇数のとき、現在のスライドを中央に表示する
  });
  $(".thumb-slider").slick({
    arrows: true, // 前・次のボタンを表示する
    dots: false, // ドットナビゲーションを表示する
    autoplay: false,
    speed: 1000, // スライドさせるスピード（ミリ秒）
    slidesToShow: 5, // 表示させるスライド数
    centerMode: false, // slidesToShowが奇数のとき、現在のスライドを中央に表示する
    responsive: [
      {
        breakpoint: 900, // 899px以下のサイズに適用
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768, // 899px以下のサイズに適用
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });
  $(".question").click(function () {
    $(".question").not(this).next().slideUp();
    $(".question").not(this).removeClass("active");
    $(this).next().slideToggle();
    $(this).toggleClass("active");
  });
  $(".readMoreInner").each(function () {
    const btn = $(this).find(".readMoreBtn");
    const content = $(this).find(".readMoreContainer");

    // 初期状態で max-height を設定 (必要なら追加)
    content.css("max-height", "200px");

    // ボタンクリックでイベント処理
    btn.on("click", function () {
      if (!content.hasClass("show")) {
        content.css("max-height", content.prop("scrollHeight") + "px");
        content.addClass("show");
        btn.text("閉じる");
      } else {
        content.css("max-height", "200px");
        content.removeClass("show");
        btn.text("もっと見る");
      }
    });
  });

  $(window).scroll(function () {
    scrollHeight = $(document).height();
    scrollPosition = $(window).height() + $(window).scrollTop();
    footHeight = $("footer").innerHeight();
    if (scrollHeight - scrollPosition <= footHeight) {
      $(".seminar-fix-btn").css({
        position: "absolute",
        bottom: "20px",
      });
      if (window.matchMedia("(max-width: 768px)").matches) {
        $(".simulation-fix-btn").css({
          position: "absolute",
          bottom: "29vw",
        });
      } else {
        $(".simulation-fix-btn").css({
          position: "absolute",
          bottom: "130px",
        });
      }
      $("#pagetop").css({
        position: "absolute",
        bottom: "20px",
      });
    } else {
      $(".seminar-fix-btn").css({
        position: "fixed",
        bottom: "20px",
      });
      if (window.matchMedia("(max-width: 768px)").matches) {
        $(".simulation-fix-btn").css({
          position: "fixed",
          bottom: "29vw",
        });
      } else {
        $(".simulation-fix-btn").css({
          position: "fixed",
          bottom: "130px",
        });
      }
      $("#pagetop").css({
        position: "fixed",
        bottom: "20px",
      });
    }
  });
  $(".inview").on("inview", function (event, isInView) {
    if (isInView) {
      $(this).stop().addClass("is-show");
    }
  });
  var pagetop = $("#pagetop");
  pagetop.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      pagetop.fadeIn();
    } else {
      pagetop.fadeOut();
    }
  });
  pagetop.click(function () {
    $("body, html").animate({ scrollTop: 0 }, 500);
    return false;
  });
});
